import React from "react";
import ItemRow from "@/components/ItemRow";
import { EmptyState } from "@/components/EmptyState";
import { relativeDateLabel } from "@/lib/dates";

// Shopping/to-do list tab body — search-result mode + normal list mode.
export default function ShoppingList({
    q, query, searchLoading, results,
    today, listItems,
    onSearchToggle, onSearchDelete,
    onToggleList, onDeleteList, onEditList, onOpenEditList,
}) {
    if (q) {
        if (results.length === 0) {
            return <EmptyState text={searchLoading ? "Searching…" : `No list items match "${query}".`} />;
        }
        return results.map((r) => (
            <ItemRow
                key={r.id}
                title={r.quantity ? `${r.title} · ${r.quantity}` : r.title}
                completed={r.completed}
                dateChip={r.date ? `for ${relativeDateLabel(r.date, today)}` : null}
                onToggle={() => onSearchToggle(r)}
                onDelete={() => onSearchDelete(r)}
                onOpenEdit={onOpenEditList ? () => onOpenEditList(r) : undefined}
                testId={`list-row-${r.id}`}
            />
        ));
    }
    return (
        <>
            {listItems.length === 0 && <EmptyState text="Empty list. Add what you need to grab." />}
            {listItems.map((i) => (
                <ItemRow
                    key={i.id}
                    title={
                        (i.quantity ? `${i.title} · ${i.quantity}` : i.title)
                        + (i.for_date && i.for_date !== today ? `  · for ${i.for_date}` : "")
                    }
                    editableTitle={i.quantity ? `${i.title} · ${i.quantity}` : i.title}
                    completed={i.completed}
                    onToggle={() => onToggleList(i)}
                    onDelete={() => onDeleteList(i)}
                    onOpenEdit={onOpenEditList ? () => onOpenEditList(i) : undefined}
                    onEditTitle={onEditList ? (next) => {
                        // Allow "Title · Quantity" inline edit: anything after the
                        // first " · " becomes the new quantity, before it becomes the title.
                        const sep = next.indexOf(" · ");
                        if (sep > 0) {
                            const newTitle = next.slice(0, sep).trim();
                            const newQty = next.slice(sep + 3).trim();
                            return onEditList(i, { title: newTitle, quantity: newQty });
                        }
                        // Single value → treat as title; clear quantity to avoid stale duplication.
                        return onEditList(i, { title: next, quantity: "" });
                    } : undefined}
                    testId={`list-row-${i.id}`}
                />
            ))}
        </>
    );
}
